import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { DeviceAssignmentHistoryEffects } from './device-assignment-history.effects';
import { deviceAssignmentHistoryReducer } from './device-assignment-history.reducer';

export const provideDeviceAssignmentHistoryStore = () => [
  provideState('device-assignment-history', deviceAssignmentHistoryReducer),
  provideEffects([DeviceAssignmentHistoryEffects]),
];
